export function onlineThreeProgressBar(){
    $('.schedule-list').removeClass('schedule-list');
    $('.service-information').addClass("d-none");
    $('.progress, .progressbar').show();
}